var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-as-new"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":`Login as ${_vm.user.first_name} on app.syncvault.com`,"placement":"top"}},[_c('i',{staticClass:"el-icon-s-promotion",on:{"click":_vm.loginAsUserNew}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }